import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import SwitchList from "../../../../../ui/SwitchList";

const digitalUsageItems = [
  { id: 1, label: "полный курс" },
  {
    id: 2,
    label: "цифровые учебные материалы с распределением по занятиям"
  },
  {
    id: 3,
    label: "цифровые учебные материалы не используются"
  }
];

const useStyles = makeStyles({
  content: {
    boxSizing: "border-box",
    "& .MuiFormControl-root": {
      width: "100%",
      marginBottom: "10px"
    },
    "& > span": {
      fontSize: "14px",
      lineHeight: "18px"
    }
  }
});

const DigitalTrainingMaterials = ({ title, moduleDigitalUsage, change }) => {
  const { content } = useStyles();
  const { digitalUsage } = moduleDigitalUsage.data;

  const changeTrainingMaterial = e => {
    change("digitalUsage", parseInt(e.target.value, 10));
  };

  return (
    <div className={content}>
      <span>{title}</span>
      <SwitchList
        items={digitalUsageItems}
        labelPlacement="end"
        value={digitalUsage || 3}
        change={changeTrainingMaterial}
      />
    </div>
  );
};

export default DigitalTrainingMaterials;
